import { createFileRoute } from "@tanstack/react-router";
import MyReservations from "@/pages/MyReservations";
import { buildNoindexHead, noindexLoader, type NoindexSEO } from "@/lib/noindex-route-seo";

const TITLES: NoindexSEO = {
  "es": "Mis reservas",
  "pt-BR": "Minhas reservas",
  "en": "My reservations",
  "en-EU": "My reservations",
};

export const Route = createFileRoute("/my-reservations")({
  loader: noindexLoader,
  head: ({ loaderData }) => buildNoindexHead(TITLES, "/my-reservations", loaderData),
  component: MyReservations,
});
